
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';

import UpdateIcon from '@mui/icons-material/Update';
import { deleteObjectApi } from 'api/general';
import { UNITS } from 'app/utils/constants/customConstant';
import Swal from 'sweetalert2';
import AddUpdateUnitDialog from '../../Dialog/AddUpdateUnitDialog';
import UnitDataTableToolbar from './UnitDataTableToolbar';
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import { useSelector } from 'react-redux';
import { highlightText, isRoleCheckList } from 'app/utils/appHelpers';


function UnitDataTable({ mainData = [], column, pageTitle }) {

    const { authUser } = useSelector(state => state.auth);

    const [data, setData] = useState([]);
    const [data2, setData2] = useState([]);

    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const [updateInfoDialogStatus, setUpdateInfoDialogStatus] = useState(false);
    const [selectedUnit, setSelectedUnit] = useState();
    const [highlightQuery, setHighlightQuery] = useState('');

    useEffect(() => {
        setData([...mainData]);
        setData2([...mainData]);
    }, [mainData]);

    const updateAfterTable = (item) => {
        let tmp = data;
        const index = data.findIndex(x => x.id === item.id);
        index !== -1 ? tmp[index] = item : tmp.push({ ...item, id: Number(data[data.length - 1].id) + 1 })
        setData([...tmp]);
        setData2([...tmp]);
    }

    const addAfterTable = (unit) => { let tmp = data; tmp.unshift(unit); setData(tmp) }

    const handleRequestSort = (event, property) => {

        const tempOrderBy = property;
        let tempOrder = 'desc';

        if (orderBy === property && order === 'desc') {
            tempOrder = 'asc';
        }
        const tempdata =
            tempOrder === 'desc'
                ? data.sort((a, b) => (b[tempOrderBy] < a[tempOrderBy] ? -1 : 1))
                : data.sort((a, b) => (a[tempOrderBy] < b[tempOrderBy] ? -1 : 1));


        setData(tempdata);
        setOrder(tempOrder);
        setOrderBy(tempOrderBy);

    };

    const DataTableHead = ({ onRequestSort, customColumnData }) => {

        const createSortHandler = property => event => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <TableRow>
                    {customColumnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                align={column.numeric}
                                padding={column.disablePadding ? 'none' : 'normal'}
                            >
                                <Tooltip
                                    title="Sırala"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    };


    const updateUnitInfo = (unit) => {
        setSelectedUnit(unit)
        setUpdateInfoDialogStatus(true)
    }


    const deleteItem = (item) => {
        Swal.fire({
            title: 'Silme İşlemi',
            text: "'" + item.name + "' başlıklı birimi silmek istediğinizden emin misiniz?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet Sil',
            cancelButtonText: "Vazgeç"
        }).then(async (result) => {
            if (result.isConfirmed) {
                const result = await deleteObjectApi(UNITS, item.id);
                setData([...data.filter(x => x.id !== item.id)])
                if (result.status) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'İşlem başarılı.',
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            }
        })
    }
    const { baseFontSize, lineHeight, iconFontSize } = useTemplateFontSettings();
    return (
        <Paper className="col-md-12">
            <UnitDataTableToolbar
                pageTitle={pageTitle}
                data2={data2}
                setData={setData}
                afterUpdateFunc={updateAfterTable}
                addAfterTable={(x) => setData([x, ...data2])}
                setHighlightQuery={setHighlightQuery}
            />

            <div className="flex-auto">
                <div className="table-responsive-material">
                    <Table className="" size='small'>
                        <DataTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={data.length}
                            customColumnData={column}
                        />
                        <TableBody>
                            {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {

                                return (
                                    <TableRow hover key={"trO" + n.id}>
                                        <TableCell align="left" padding="normal" style={{ fontSize: baseFontSize, lineHeight: lineHeight }}>{highlightText(n.inst, highlightQuery)}</TableCell>
                                        <TableCell align="left" padding="none" style={{ fontSize: baseFontSize, lineHeight: lineHeight }}>{highlightText(n.name, highlightQuery)}</TableCell>

                                        <TableCell align="left" padding="normal" style={{ fontSize: baseFontSize, lineHeight: lineHeight }}>
                                            {n.uploadFileStatus === 1 ? "Evet" : "Hayır"}
                                        </TableCell>
                                        <TableCell align="left" padding="none" >

                                            {isRoleCheckList(authUser.userRoles, [1, 373, 370]) && (
                                                <>
                                                    <Tooltip style={{ width: 'auto' }} title="Kurul/Kol/Komisyon Güncelle">
                                                        <Button style={{ minWidth: '40px', fontSize: iconFontSize }} key="one" onClick={() => updateUnitInfo(n)}>
                                                            <UpdateIcon color='info' fontSize='small' />
                                                        </Button>
                                                    </Tooltip>
                                                    <Tooltip title="Kurul/Kol/Komisyon Sil" >
                                                        <Button style={{ minWidth: '40px', fontSize: iconFontSize }} key="two" onClick={() => deleteItem(n)} >
                                                            <DeleteIcon color='error' fontSize='small' />
                                                        </Button>
                                                    </Tooltip>
                                                </>
                                            )}
                                        </TableCell>


                                    </TableRow>
                                );
                            })}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    count={data.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={(e, page) => setPage(page)}
                                    onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
                                    labelRowsPerPage={"Görüntülenecek Satır"}
                                    rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                                    showFirstButton
                                    showLastButton
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </div>

            {<AddUpdateUnitDialog open={updateInfoDialogStatus} onClose={() => setUpdateInfoDialogStatus(false)} afterUpdateFunc={updateAfterTable} addAfterTable={addAfterTable} selectedUnit={selectedUnit} />}
        </Paper >
    )
}

export default UnitDataTable